import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableAnswer = (props) => {
  const { answer, setAnswers } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: answer.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const [content, setContent] = useState(answer.content);
  const [isCorrect, setIsCorrect] = useState(answer.correct || false);
  const [debouncedContent, setDebouncedContent] = useState(answer.content);

  useEffect(() => {
    setAnswers((prevAnswers) =>
      prevAnswers.map((a) =>
        a.id === answer.id ? { ...a, content: content } : a,
      ),
    );
  }, [debouncedContent]);

  useEffect(() => {
    setAnswers((prevAnswers) =>
      prevAnswers.map((a) =>
        a.id === answer.id ? { ...a, correct: isCorrect } : a,
      ),
    );
  }, [isCorrect]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedContent(content);
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [content, 200]);

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-2 bg-white px-6 py-2"
    >
      <span className="text-lg cursor-move" {...attributes} {...listeners}>
        ≡
      </span>
      <input
        type="text"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="w-3/4 mt-1 border px-3 py-2 text-sm"
        placeholder="Wpisz tutaj treść odpowiedzi..."
      />
      <input
        type="checkbox"
        checked={isCorrect}
        onChange={() => setIsCorrect(!isCorrect)}
      />
      <button
        className="text-primaryYellow ml-2"
        onClick={() =>
          setAnswers((prev) => prev.filter((a) => a.id !== answer.id))
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
          />
        </svg>
      </button>
    </div>
  );
};

SortableAnswer.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    correct: PropTypes.bool,
    isNewAnswer: PropTypes.bool,
  }).isRequired,
  setAnswers: PropTypes.func.isRequired,
};

export default SortableAnswer;
